module.exports = "/images/frau-2.jpg?e44333daf76f803e92a255ef1a4d275c";